/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_X13_Error_RefusedInputs */

const en_portal_x13_error_refused = /** @type {(inputs: Portal_X13_Error_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The provider's answer could not be accepted. Use the email link instead.`)
};

/** @type {(inputs: Portal_X13_Error_RefusedInputs) => LocalizedString} */
const ar_portal_x13_error_refused = en_portal_x13_error_refused;

/** @type {(inputs: Portal_X13_Error_RefusedInputs) => LocalizedString} */
const he_portal_x13_error_refused = en_portal_x13_error_refused;

/** @type {(inputs: Portal_X13_Error_RefusedInputs) => LocalizedString} */
const ur_portal_x13_error_refused = en_portal_x13_error_refused;

/** @type {(inputs: Portal_X13_Error_RefusedInputs) => LocalizedString} */
const es_portal_x13_error_refused = en_portal_x13_error_refused;

/** @type {(inputs: Portal_X13_Error_RefusedInputs) => LocalizedString} */
const fr_portal_x13_error_refused = en_portal_x13_error_refused;

/** @type {(inputs: Portal_X13_Error_RefusedInputs) => LocalizedString} */
const de_portal_x13_error_refused = en_portal_x13_error_refused;

/** @type {(inputs: Portal_X13_Error_RefusedInputs) => LocalizedString} */
const pt_portal_x13_error_refused = en_portal_x13_error_refused;

/** @type {(inputs: Portal_X13_Error_RefusedInputs) => LocalizedString} */
const hi_portal_x13_error_refused = en_portal_x13_error_refused;

/** @type {(inputs: Portal_X13_Error_RefusedInputs) => LocalizedString} */
const bn_portal_x13_error_refused = en_portal_x13_error_refused;

/**
* | output |
* | --- |
* | "The provider's answer could not be accepted. Use the email link instead." |
*
* @param {Portal_X13_Error_RefusedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portal_x13_error_refused = /** @type {((inputs?: Portal_X13_Error_RefusedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_X13_Error_RefusedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portal_x13_error_refused(inputs)
	if (locale === "he") return he_portal_x13_error_refused(inputs)
	if (locale === "ur") return ur_portal_x13_error_refused(inputs)
	if (locale === "es") return es_portal_x13_error_refused(inputs)
	if (locale === "fr") return fr_portal_x13_error_refused(inputs)
	if (locale === "de") return de_portal_x13_error_refused(inputs)
	if (locale === "pt") return pt_portal_x13_error_refused(inputs)
	if (locale === "hi") return hi_portal_x13_error_refused(inputs)
	if (locale === "bn") return bn_portal_x13_error_refused(inputs)
	return /** @type {LocalizedString} */ ("The provider's answer could not be accepted. Use the email link instead.")
});